import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/integrations/whatsapp';

const whapiService = {
  /** Fetch normalised channel status (status_text, is_connected, connected_phone, ...). */
  getStatus: async () => {
    const response = await apiClient.get(`${BASE}/status`);
    return response.data;
  },

  /**
   * Fetch the pairing QR PNG as a Blob (so cookies are sent through apiClient)
   * and return a browser-local object URL suitable for use as <img src>.
   * Caller is responsible for revoking the URL via URL.revokeObjectURL when done.
   */
  fetchQrObjectUrl: async () => {
    const response = await apiClient.get(`${BASE}/qr`, {
      responseType: 'blob',
      headers: { Accept: 'image/png' },
    });
    return URL.createObjectURL(response.data);
  },

  /** Disconnect the channel (Whapi POST /users/logout). */
  logout: async () => {
    const response = await apiClient.post(`${BASE}/logout`);
    return response.data;
  },

  /** Chatbot webhook URL and env flags for Whapi dashboard setup. */
  getChatbotConfig: async () => {
    const response = await apiClient.get(`${BASE}/chatbot-config`);
    return response.data;
  },

  /** Push chatbot webhook URL + Bearer header to Whapi via PATCH /settings. */
  configureChatbotWebhook: async (payload = {}) => {
    const response = await apiClient.post(`${BASE}/chatbot/webhook/configure`, payload);
    return response.data;
  },

  /** Ask Whapi to send a test messages webhook to our URL. */
  testChatbotWebhook: async (payload = {}) => {
    const response = await apiClient.post(`${BASE}/chatbot/webhook/test`, payload);
    return response.data;
  },
};

export default whapiService;
